import styled, { css } from 'styled-components';

import { ListItem as MuiListItem, List as MuiList } from '@mui/material';

export const List = styled(MuiList)`
  padding-top: 0;
`;

export const ListItem = styled(MuiListItem)`
  ${({ theme }) => css`
    border-bottom: 1px solid ${theme.yoga.colors.moduleBorder};
  `}
`;
